import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  appPageContent: {
    flex: "auto",
    display: "flex",
    height: "100%",
    "&.centeredContent": {
      display: "flex",
      justifyContent: "center"
    }
  }
}));
